"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.httpLink = exports.customFetch = void 0;
const client_1 = require("@apollo/client");
/**
 * Customized fetch function that:
 * - normalizes headers to lowercase keys
 * - trims GraphQL queries
 * - sets default content-type
 *
 * @param input Request
 * @param init RequestInit
 * @returns Response
 */
const customFetch = async (input, init = {}) => {
    const rawHeaders = init.headers || {};
    const lowerCasedHeaders = Object.keys(rawHeaders).reduce((acc, key) => {
        const value = rawHeaders[key];
        if (value)
            acc[key.toLowerCase()] = value;
        return acc;
    }, {});
    if (!("content-type" in lowerCasedHeaders)) {
        lowerCasedHeaders["content-type"] = "text/plain;charset=UTF-8";
    }
    if (init.body && typeof init.body === "string") {
        const parsedBody = JSON.parse(init.body);
        if (parsedBody?.query && typeof parsedBody.query === "string") {
            parsedBody.query = parsedBody.query.trim();
            init.body = JSON.stringify(parsedBody);
        }
    }
    init.headers = lowerCasedHeaders;
    return fetch(input, init);
};
exports.customFetch = customFetch;
const httpLink = (uri) => new client_1.HttpLink({
    uri,
    fetch: exports.customFetch,
    includeExtensions: true,
});
exports.httpLink = httpLink;
//# sourceMappingURL=http-link.js.map